import { $t } from '@/i18n';
import XyPageletRenderer from './xy-pagelet-renderer.vue';
import XyPageletSchema from './xy-pagelet-schema';
import { meta as XyInnerPageletSelectorMeta } from './xy-inner-pagelet-selector.vue';
import { XyPageletPropsEditorMeta } from '../uicorePlugin/paramsFormComponents';
import Vue from 'vue';
import logger from '@utils/logger';

export default {
  component: XyPageletRenderer,
  componentForDesign: XyPageletRenderer,
  category: $t('k_f6384246'),
  id: 'xy-pagelet-renderer',
  events: [
    {
      id: 'presetEventA',
      name: $t('k_22042ed4'),
      desc: $t('k_d79bdc25'),
    },
    {
      id: 'presetEventB',
      name: $t('k_2ba647c1'),
      desc: $t('k_a956fbce'),
    },
    {
      id: 'presetEventC',
      name: $t('k_411bd345'),
      desc: $t('k_23c9346'),
    },
    {
      id: 'presetEventD',
      name: $t('k_fb29d0db'),
      desc: $t('k_b1df00e9'),
    },
    {
      id: 'presetEventE',
      name: $t('k_cb2c0538'),
      desc: $t('k_b0c5c32a'),
    },
  ],
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-page-let-renderer_1636364733590.png',
  slots: [],
  display: 'block',
  visible: false,
  name: $t('k_dcc4a296'),
  order: 1,
  propPanel: {
    XyInnerPageSelector: XyInnerPageletSelectorMeta,
    XyPageletPropsEditor: XyPageletPropsEditorMeta,
  },
  readme: '',
  propsSchema: XyPageletSchema,
  getActions({ modifyComp }) {
    return [
      {
        title: $t('k_a28ee87e'),
        icon: 'fa fa-refresh',
        async execute() {
          await modifyComp((c) => {
            logger.info(c);
            Vue.set(c, 'type', 'xy-page-container');
            Vue.set(c.props, 'type', 'pagelet');
          });
        },
      },
    ];
  },
};
